module.exports = __webpack_public_path__ + "static/media/ruleImg2.5e5e1a4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/ruleImg2.png
// module id = 1853
// module chunks = 0 1